var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-bg-white btn-text-dark-50 btn-icon-primary btn-hover-primary font-weight-bold px-5 text-center",attrs:{"href":_vm.linkToDocumentation,"target":"_blank"}},[_c('i',{staticClass:"color-inherit p-0",class:[_vm.icon]})])
}
var staticRenderFns = []

export { render, staticRenderFns }